// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1qk7L","title":"ClientReferral_title__2peiV","itemText":"ClientReferral_itemText__1kAoz"};